import { post, get, put, remove } from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
  DEFAULT_NOTIFICATION_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_TEMPLATES_PREVIEW_START = 'FETCH_TEMPLATES_PREVIEW_START';
export const FETCH_TEMPLATES_PREVIEW_SUCCESS = 'FETCH_TEMPLATES_PREVIEW_SUCCESS';
export const FETCH_TEMPLATES_PREVIEW_FAIL = 'FETCH_TEMPLATES_PREVIEW_FAIL';
export const FETCH_TEMPLATES_PREVIEW_ALL_SUCCESS = 'FETCH_TEMPLATES_PREVIEW_ALL_SUCCESS';
export const WRITE_TEMPLATE_PREVIEW_START = 'WRITE_TEMPLATE_PREVIEW_START';
export const WRITE_TEMPLATE_PREVIEW_SUCCESS = 'WRITE_TEMPLATE_PREVIEW_SUCCESS';
export const WRITE_TEMPLATE_PREVIEW_FAIL = 'WRITE_TEMPLATE_PREVIEW_FAIL';
export const DELETE_TEMPLATE_PREVIEW_START = 'DELETE_TEMPLATE_PREVIEW_START';
export const DELETE_TEMPLATE_PREVIEW_SUCCESS = 'DELETE_TEMPLATE_PREVIEW_SUCCESS';
export const DELETE_TEMPLATE_PREVIEW_FAIL = 'DELETE_TEMPLATE_PREVIEW_FAIL';
export const CHANGE_TEMPLATE_PREVIEW_SUCCESS = 'CHANGE_TEMPLATE_PREVIEW_SUCCESS';
export const UPDATE_TEMPLATES_PREVIEW_POSITIONS = 'UPDATE_TEMPLATES_PREVIEW_POSITIONS';
export const WRITE_TEMPLATE_PREVIEW_SET_START = 'WRITE_TEMPLATE_PREVIEW_SET_START';
export const WRITE_TEMPLATE_PREVIEW_SET_SUCCESS = 'WRITE_TEMPLATE_PREVIEW_SET_SUCCESS';
export const WRITE_TEMPLATE_PREVIEW_SET_FAIL = 'WRITE_TEMPLATE_PREVIEW_SET_FAIL';
export const CHANGE_TEMPLATE_PREVIEW_SET_SUCCESS = 'CHANGE_TEMPLATE_PREVIEW_SET_SUCCESS';
export const UPDATE_TEMPLATES_PREVIEW_SET_START = 'UPDATE_TEMPLATES_PREVIEW_SET_START';
export const UPDATE_TEMPLATES_PREVIEW_SET_FAIL = 'UPDATE_TEMPLATES_PREVIEW_SET_FAIL';

const writeAttributesSetStart = () => ({
  type: WRITE_TEMPLATE_PREVIEW_SET_START,
});

const writeAttributesSetFail = (err) => ({
  type: WRITE_TEMPLATE_PREVIEW_SET_FAIL,
  payload: err,
});

const changeAttributesSetSuccess = (changedSet) => ({
  type: CHANGE_TEMPLATE_PREVIEW_SET_SUCCESS,
  payload: changedSet,
});

const fetchTemplatesStart = () => ({
  type: FETCH_TEMPLATES_PREVIEW_START,
});

const fetchTemplatesSuccess = (data, dataType) => ({
  type: FETCH_TEMPLATES_PREVIEW_SUCCESS,
  payload: { data, dataType },
});

const fetchAllTemplatesSuccess = (data) => ({
  type: FETCH_TEMPLATES_PREVIEW_ALL_SUCCESS,
  payload: data,
});

const fetchTemplatesFail = (err) => ({
  type: FETCH_TEMPLATES_PREVIEW_FAIL,
  payload: err,
});

const writeTemplateStart = () => ({
  type: WRITE_TEMPLATE_PREVIEW_START,
});

const writeTemplateSuccess = (newTemplate) => ({
  type: WRITE_TEMPLATE_PREVIEW_SUCCESS,
  payload: newTemplate,
});

const writeTemplateFail = (err) => ({
  type: WRITE_TEMPLATE_PREVIEW_FAIL,
  payload: err,
});

const deleteTemplateStart = () => ({
  type: DELETE_TEMPLATE_PREVIEW_START,
});

const deleteTemplateSuccess = (payload) => {
  return {
    type: DELETE_TEMPLATE_PREVIEW_SUCCESS,
    payload,
  };
};

const deleteTemplateFail = (err) => ({
  type: DELETE_TEMPLATE_PREVIEW_FAIL,
  payload: err,
});

export const updateTemplatePreviewsPositions = (payload) => ({
  type: UPDATE_TEMPLATES_PREVIEW_POSITIONS,
  payload,
});

const updateTemplatePreviewSetStart = () => ({
  type: UPDATE_TEMPLATES_PREVIEW_SET_START,
});

const updateTemplatePreviewSetFail = (error) => ({
  type: UPDATE_TEMPLATES_PREVIEW_SET_FAIL,
  payload: error,
});

export const fetchAllTemplatePreviews = () => async (dispatch) => {
  dispatch(fetchTemplatesStart());
  try {
    const result = await get('/template-previews');
    dispatch(fetchAllTemplatesSuccess(result.data));
    return result;
  } catch (e) {
    dispatch(fetchTemplatesFail(e));
  }
};

export const fetchTemplatePreviews = (type) => async (dispatch) => {
  dispatch(fetchTemplatesStart());
  try {
    const result = await get(`/template-previews?type=${type}`);
    dispatch(fetchTemplatesSuccess(result.data, type));
  } catch (e) {
    dispatch(fetchTemplatesFail(e));
  }
};

export const writeTemplatePreviews = (newTemplate, translations, setNewItemProcess) => async (dispatch) => {
  dispatch(writeTemplateStart());
  try {
    const result = await post('/template-previews', newTemplate);
    dispatch(writeTemplateSuccess(result.data));
    setNewItemProcess((prev) => prev.filter((elId) => elId !== newTemplate.identifier));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    // @todo: улучшить
    dispatch(fetchAllTemplatePreviews());
    return result.data;
  } catch (e) {
    dispatch(writeTemplateFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
  }
};

export const deleteTemplatePreviews = (payload, translations, setDeleteProcess) => async (dispatch) => {
  dispatch(deleteTemplateStart());
  try {
    await remove(`/template-previews/${payload}`);
    dispatch(deleteTemplateSuccess(payload));
    setDeleteProcess((prev) => prev.filter((elId) => elId !== payload));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    dispatch(deleteTemplateFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
  }
};

export const changeTemplatePreviews = (payload, translations, silent = false) =>
  async (dispatch) => {
    dispatch(writeTemplateStart());
    try {
      await put(`/template-previews/${payload.id}`, payload);
      // @todo: улучшить
      const result = await dispatch(fetchAllTemplatePreviews());
      if (!silent) {
        Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      }
      return result;
    } catch (e) {
      dispatch(writeTemplateFail(e));
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    }
  };

/**
 * Явная перегенерация превью у уже загруженных файлов, ссылающихся на шаблон.
 *
 * Изменение пропорций шаблона действует только на новые загрузки — у уже сохранённых
 * изображений previewLink остаётся прежним, пока перегенерацию не запустят. Работа
 * выполняется асинхронно, поэтому ответ лишь подтверждает постановку в очередь и
 * сообщает, сколько наборов атрибутов затронуто: affectedAttributeSets === 0 означает,
 * что перекраивать нечего и изменение повлияет только на новые загрузки.
 */
export const regenerateTemplatePreviews = (id, translations) => async (dispatch) => {
  dispatch(writeTemplateStart());
  try {
    const result = await post(`/template-previews/${id}/regenerate`, {});

    Store.addNotification({
      ...DEFAULT_NOTIFICATION_SUCCESS,
      title: translations?.formManagement_successfully,
      message: result?.data?.message ?? translations?.common_success_message,
      dismiss: { duration: 6000, showIcon: true },
    });

    return result.data;
  } catch (e) {
    dispatch(writeTemplateFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  }
};

export const getTemplatePreviewsPage = (id) => async () => {
  try {
    const result = await get(`/template-previews/${id}`);
    return result.data ?? null;
  } catch (e) {
    console.error('getTemplatePreviewsPage error:', e);
    return null;
  }
};

export const updateTemplatePreviewSet = (locale, translations, silent = true) =>
  async (dispatch) => {
    dispatch(updateTemplatePreviewSetStart());
    try {
      const result = await put(`/locales/${locale.id}`, locale);
      if (!silent && !!result?.data) {
        Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      }
      return true;
    } catch (e) {
      console.error('updateTemplatePreviewSet error:', e);
      dispatch(updateTemplatePreviewSetFail(e));
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
      return false;
    }
  };

export const getTemplatePreviewSet = (id) => async () => {
  try {
    const result = await get(`/template-preview/schema/${id}`);
    return result.data ?? null;
  } catch (e) {
    console.error('getTemplatePreviewSet error:', e);
    return null;
  }
};

export const changeTemplatePreview = (pageObject, translations, deleted, deletedId) => async (dispatch) => {
  dispatch(writeAttributesSetStart());
  try {
    await put(`/template-previews/${pageObject.id}`, {
      ...pageObject,
      deleted,
      deletedId,
    });
    dispatch(changeAttributesSetSuccess(pageObject));
    // @deprecated
    // dispatch(getSettings());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(writeAttributesSetFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};
